import { DropdownMenu, Icon, Menu } from "semantic-ui-react";

import { Dropdown } from "components";
import { Link } from "components/ReactScroll/index";
import { useOverflowingSectionMenus } from "components/ScrollToSectionMenu/hooks";
import "components/ScrollToSectionMenu/ScrollToSectionMenu.scss";

export type SectionMenu = {
  id: string;
  title: string;
  icon?: string;
  count?: number;
  showEmpty?: boolean;
};

type ScrollToSectionMenuProps = {
  sectionMenus: Record<string, SectionMenu>;
  offset?: number;
  hideBorder?: boolean;
};

export const ScrollToSectionMenu = ({ sectionMenus, offset = -100, hideBorder }: ScrollToSectionMenuProps) => {
  const { canSpy, setActiveSectionMenu, activeSectionMenu, handleSectionMenuClick, menuContainerRef, visibleSectionMenus, overflowingSectionMenus } =
    useOverflowingSectionMenus(sectionMenus);

  const renderMenuEntry = (entry: SectionMenu) => {
    if (!entry.count && !entry.showEmpty) return null;
    const count = entry.count ? <span>({entry.count})</span> : null;

    return (
      <Link
        key={entry.id}
        to={entry.id}
        spy={canSpy}
        smooth={true}
        offset={offset}
        duration={300}
        onSetActive={() => setActiveSectionMenu(entry.id)}
        containerId="containerId"
      >
        <Menu.Item as="span" active={entry.id === activeSectionMenu} onClick={() => handleSectionMenuClick(entry.id)}>
          {entry.icon ? <Icon className={entry.icon} /> : entry.title}
          {count}
        </Menu.Item>
      </Link>
    );
  };

  return (
    <div ref={menuContainerRef} className={`scrollToSectionMenu-container ${hideBorder ? "hideBorder" : ""}`} style={{ position: "relative" }}>
      <Menu pointing secondary color="green">
        {visibleSectionMenus.map(renderMenuEntry)}

        {overflowingSectionMenus.length > 0 && (
          <Dropdown item icon="ellipsis horizontal" className="overflow-dropdown" pointing="top right" style={{ marginLeft: "auto" }}>
            <DropdownMenu>
              {overflowingSectionMenus.map(menu => (
                <Link
                  key={menu.id}
                  to={menu.id}
                  spy={canSpy}
                  smooth={true}
                  offset={offset}
                  duration={300}
                  onSetActive={() => setActiveSectionMenu(menu.id)}
                  containerId="containerId"
                >
                  <Menu.Item as="span" className="dropdown-menu-item" active={menu.id === activeSectionMenu} onClick={() => handleSectionMenuClick(menu.id)}>
                    {menu.icon ? <Icon className={menu.icon} /> : menu.title}
                    {menu.count ? <span>({menu.count})</span> : null}
                  </Menu.Item>
                </Link>
              ))}
            </DropdownMenu>
          </Dropdown>
        )}
      </Menu>
    </div>
  );
};

export default ScrollToSectionMenu;
